// extracted by mini-css-extract-plugin
export default {"container":"GraphSpecs_container__Eysv7","parameterGroup":"GraphSpecs_parameterGroup__M4M17"};